/* RESPONSIBLE TEAM: team-ai-agent */
import IntercomRoute from 'embercom/routes/base/intercom-route';
import { inject as service } from '@ember/service';
import { type Router } from '@ember/routing';

export default class CustomerSupportFinRoute extends IntercomRoute {
  @service declare router: Router;

  beforeModel() {
    this.router.transitionTo('apps.app.reports.customer-support.fin-ai-agent');
  }
}
